/**
 * @generated SignedSource<<17daaa07a284161e6100f92fddd403ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SalesforceInstanceType = "NOTE" | "TASK";
export type SalesforceUpdateSettingsInput = {
  autoSendNotesEnabled: boolean;
  clientMutationId?: string | null;
  createInSalesforceAs: SalesforceInstanceType;
  includeRecapInAutoSendNotes: boolean;
  relateToAccount: boolean;
  relateToOpportunity: boolean;
};
export type SalesforceIntegrationUpdateSettingsMutation$variables = {
  input: SalesforceUpdateSettingsInput;
};
export type SalesforceIntegrationUpdateSettingsMutation$data = {
  readonly salesforceUpdateSettings: {
    readonly ok: boolean;
  } | null;
};
export type SalesforceIntegrationUpdateSettingsMutation = {
  response: SalesforceIntegrationUpdateSettingsMutation$data;
  variables: SalesforceIntegrationUpdateSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SalesforceUpdateSettingsPayload",
    "kind": "LinkedField",
    "name": "salesforceUpdateSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceIntegrationUpdateSettingsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesforceIntegrationUpdateSettingsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4908f9eb90c62a4a477a59c8770ed7dd",
    "id": null,
    "metadata": {},
    "name": "SalesforceIntegrationUpdateSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation SalesforceIntegrationUpdateSettingsMutation(\n  $input: SalesforceUpdateSettingsInput!\n) {\n  salesforceUpdateSettings(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab733a712bc831a100ec200343d68628";

export default node;
